export { default as Fade } from './Fade';
